<template>
  <div class="mobile-product">
    <!-- 产品分类 -->
    <div class="category-list">
      <div
        v-for="(item, index) in categories"
        :key="index"
        class="category-item"
        :class="{ active: currentCategory === item.id }"
        @click="handleCategoryChange(item.id)"
      >
        {{ item.title }}
      </div>
    </div>

    <!-- 产品列表 -->
    <div class="product-list">
      <div
        v-for="(item, index) in productList"
        :key="index"
        class="product-item"
        @click="goToDetail(item)"
      >
        <div class="product-image"  v-if="!selectedProduct">
          <img :src="item.image" :alt="item.title">
          <div class="product-image-info">
            <div class="product-title">{{ item.title }}</div>
            <p class="product-body">
              <span class="product-desc" v-html="$formatContent(item.content, 29)"></span>
              <span class="show-more" @click="goToDetail(item)">查看更多</span>
            </p>
          </div>
        </div>
        <div class="product-info" v-else>
          <el-button type="text" icon="el-icon-arrow-left" @click="backToList" style="margin-bottom: 16px;">返回</el-button>
          <div class="title">{{ item.title }}</div>
          <div class="desc" v-html="item.content"></div>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="load-more" v-if="hasMore" @click="loadMore">
      <span v-if="!loading">加载更多</span>
      <span v-else>加载中...</span>
    </div>
  </div>
</template>

<script>
import { articleList, articleClass } from '@/api/index'
export default {
  name: 'MobileProduct',
  data() {
    return {
      categories: [],
      currentCategory: null,
      productList: [],
      page: 1,
      pageSize: 10,
      hasMore: true,
      loading: false,
      selectedProduct: null
    }
  },
  created() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      articleClass({classify_id: 11}).then(res => {
        if (res.data) {
          this.categories = res.data.rows
          if (this.categories.length > 0) {
            this.currentCategory = this.categories[0].id
            this.getProducts(this.currentCategory)
          }
        }
      })
    },
    getProducts(id) {
      this.loading = true
      articleList({
        classify_id: id
      }).then(res => {
        this.loading = false
        if (res.data.rows) {
          this.productList = res.data.rows.filter(item => item.status !== 0)
        } else {
          this.productList = []
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleCategoryChange(categoryId) {
      this.currentCategory = categoryId
      this.productList = []
      this.getProducts(this.currentCategory)
    },
    loadMore() {
      if (this.loading) return
    },
    goToDetail(item) {
      this.selectedProduct = item
    },
    backToList() {
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="scss" scoped>
.mobile-product {
  padding: 15px;
}

.category-list {
  display: flex;
  overflow-x: auto;
  margin-bottom: 15px;
  padding-bottom: 10px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  .category-item {
    flex-shrink: 0;
    padding: 8px 15px;
    margin-right: 10px;
    background: #f5f5f5;
    border-radius: 20px;
    font-size: 14px;
    color: #666;
    white-space: nowrap;

    &.active {
      background: #2c9dcf;
      color: #fff;
    }
  }
}

.product-list {
  .product-item {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);

    .product-image {
      width: 100%;
      height: 120px;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;

      img {
        width: 120px;
        height: 100%;
        object-fit: cover;
        padding-right: 10px;
      }

      .product-title {
        font-weight: 500;
      }
      .product-desc {
        font-size: 13px;
        color: #777;
        line-height: 1.4;
        margin-top: 4px;
      }
      .show-more {
        font-size: 12px;
        color: #2c9dcf;
        margin-top: 4px;
        cursor: pointer;
      }
    }

    .product-info {
      padding: 15px;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 8px;
      }

      .desc {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
        margin-bottom: 10px;
      }

      .tags {
        display: flex;
        flex-wrap: wrap;

        .tag {
          padding: 4px 8px;
          background: #f5f5f5;
          border-radius: 4px;
          font-size: 12px;
          color: #666;
          margin-right: 8px;
          margin-bottom: 8px;
        }
      }
    }
  }
}

.load-more {
  text-align: center;
  padding: 15px 0;
  color: #666;
  font-size: 14px;
}
</style>
